import styled from 'styled-components';

export const Container = styled.div`
  padding: 32px;

  @media (max-height: 740px) {
    padding: 26px;
  }
`;

export const HeaderWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const OrderNumberWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LabelOrder = styled.span`
  font-family: 'Mangueira Bold', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 37px;
  color: #3d3d3d;

  @media (max-height: 740px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const LabelNumber = styled(LabelOrder)`
  color: #0b29fb;

  @media (max-height: 740px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const LabelProcess = styled(LabelOrder)`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;

  @media (max-height: 740px) {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    font-size: 16px;
    line-height: 24px;
  }
`;

export const CloseButton = styled.div``;

export const HeaderTextWrapper = styled.div``;

export const OrderDateWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LabelDate = styled.span`
  font-family: 'Mangueira Medium', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #3d3d3d;

  @media (max-height: 740px) {
    font-size: 12px;
  }
`;

export const LabelDateInfo = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #3d3d3d;

  @media (max-height: 740px) {
    font-size: 18px;
  }
`;

export const ContainerStatus = styled.div`
  margin-top: 32px;
  border: 1px solid #cbcbcb;
  padding: 18px 32px;
  border-radius: 8px;

  @media (max-height: 740px) {
    margin-top: 16px;
    padding: 12px 32px;
  }

  @media (max-width: 768px) {
    margin-top: 18px;
  }
`;

export const ContainerStatusHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StatusTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatusIcon = styled.div`
  width: 6px;
  height: 6px;
  background: #0b29fb;
  border-radius: 50%;
  margin-bottom: 2px;
`;

export const StatusText = styled.span`
  font-family: 'Mangueira Medium', sans-serif;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #0b29fb;
`;

export const ProtocolWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ProtocolLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;
`;

export const ProtocolNumber = styled(ProtocolLabel)`
  font-family: 'Mangueira Medium', sans-serif;
  font-weight: 500;
`;

export const CloseIcon = styled.span`
  font-size: 1.25rem;
  width: 18px;
  height: 18px;
  margin-top: -50px;
  margin-right: -15px;
  color: #3d3d3d;
  cursor: pointer;

  @media (max-width: 370px) {
    font-size: 1.125rem;
  }

  @media (max-height: 740px) {
    margin-right: -8px;
  }
`;

export const StatusContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 12px;

  @media (max-height: 740px) {
    margin-top: 8px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }
`;

export const ContainerDataWrapper = styled.div`
  margin-top: 28px;
  display: flex;
  align-items: center;
  gap: 26px;
  height: calc(100% - 132px);
  align-items: flex-start;

  @media (max-height: 740px) {
    margin-top: 16px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    margin-top: 18px;
    gap: 18px;
  }
`;

export const ContainerTracking = styled.div`
  border: 1px solid #cbcbcb;
  border-radius: 8px;
  flex: 1;
  height: calc(100% - 90px);
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-height: 640px) {
    height: calc(100% - 48px);
  }
`;

export const ContainerRefuelData = styled.div`
  border: 1px solid #cbcbcb;
  border-radius: 8px;
  flex: 1;
  height: calc(100% - 90px);
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 640px) {
    height: 100%;
  }

  @media (max-height: 640px) {
    height: calc(100% - 48px);
  }
`;

export const ContainerTrackingWrapper = styled.div`
  padding: 32px;

  @media (max-height: 740px) {
    padding: 18px 32px;
    padding-bottom: 6px;
  }
`;

export const ContainerRefuelDataWrapper = styled.div`
  padding: 32px;

  @media (max-height: 740px) {
    padding: 12px 32px;
    padding-bottom: 6px;
  }
`;

export const UllyWrapperContainer = styled.div`
  padding: 32px;
  border-top: 1px solid #cbcbcb;

  @media (max-height: 740px) {
    padding: 6px 32px;
  }

  @media (max-width: 768px) {
    padding: 22px;
  }
`;

export const ResumeTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;

  @media (max-height: 740px) {
    font-size: 14px;
  }
`;

export const ResumeItemsWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-height: 740px) {
    margin-top: 16px;
  }

  @media (max-width: 768px) {
    margin: unset;
  }

  @media (max-height: 740px) {
    gap: 16px;
    margin: 12px 20px;

    max-height: 220px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #aaa;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #999;
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }

  @media (max-height: 640px) {
    margin: 8px 20px;
    max-height: 148px;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #aaa;
    }

    &::-webkit-scrollbar-thumb:active {
      background-color: #999;
    }

    &::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }
`;

export const ResumeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 21px;
`;

export const ResumeItemIconWrapper = styled.div``;

export const ResumeItemInfosWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ResumeItemTitle = styled.span`
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 14px;
  color: #3d3d3d;
  line-height: 21px;
`;

export const ResumeItemInfo = styled(ResumeItemTitle)`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
`;

export const ResumeItemIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const UllyTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;

  @media (max-height: 740px) {
    font-size: 12px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 21px;
  }
`;

export const UllyContainerWrapper = styled.div`
  margin-top: 16px;
  background: #eff0f0;
  border-radius: 8px;
  padding: 18px 24px;
  display: flex;
  align-items: center;
  gap: 20px;

  @media (max-width: 640px) {
    flex-direction: column;
  }

  @media (max-height: 740px) {
    margin-top: 0px;
    padding: 4px 24px;
  }

  @media (max-width: 640px) {
    flex-direction: column;
  }
`;

export const UllyImage = styled.div``;

export const UllyIcon = styled.img`
  @media (max-height: 740px) {
    width: 38px;
    height: 38px;
  }
`;

export const UllyTextWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex: 1;
`;

export const UllyInfosWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const UllyLabel = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #3d3d3d;
`;

export const UllyText = styled(UllyLabel)`
  font-weight: 700;
  color: #0b29fb;
  cursor: pointer;
`;

export const IconClick = styled.div``;

export const IconChat = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

export const TrackingInfosContainer = styled.div``;

export const TrackingInfoTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TrackingInfoTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;

  @media (max-height: 740px) {
    font-size: 14px;
  }
`;

export const TrackingInfoSubtitle = styled(TrackingInfoTitle)`
  font-weight: 400;
  font-size: 12px;
`;

export const TrackingTimeLineWrapper = styled.div`
  margin-top: 32px;

  @media (max-width: 640px) {
    margin-top: 18px;
  }

  @media (max-height: 740px) {
    margin-top: 16px;
  }
`;
